import api from "@/lib/api";
import { toast } from "sonner";
import { showPaywall } from "@/lib/paywall";

// Charge a draw lookup (idempotent per rodeo — re-opening the same rodeo is free).
// Returns { ok: true } when the draw may be shown (free trial, plan-included, already
// unlocked, no real draw, or a credit was spent), or { ok: false, paywall: true } when the
// rider has hit the paywall (a toast with a "See plans" action is shown here).
export async function unlockDraw(rodeoId) {
  try {
    const { data } = await api.post(`/rodeos/${rodeoId}/draw/unlock`);
    if (data?.charged) toast.success(`Draw unlocked · ${data.charged} credit used`);
    window.dispatchEvent(new Event("rp-credits-refresh"));
    return { ok: true };
  } catch (e) {
    const d = e?.response?.data?.detail;
    if (e?.response?.status === 402 && d) {
      showPaywall({ ...d, feature: "draw lookup" });
      return { ok: false, paywall: true };
    }
    // Any other error: don't block the rider from seeing the draw.
    return { ok: true };
  }
}
